export const translations = {
  ru: {
    navigation: {
      about: "О компании",
      products: "Продукты",
      services: "Услуги",
      news: "Новости",
      contact: "Контакты",
      connect: "Связаться"
    },
    language: {
      ru: "Русский",
      en: "English"
    },
    footer: {
      description: "Разработка программного обеспечения для ритейла, ecommerce и логистики.",
      navigation: "Навигация",
      home: "Главная",
      about: "О компании",
      products: "Продукты",
      services: "Услуги",
      resources: "Ресурсы",
      news: "Новости",
      contacts: "Контакты",
      address: "г. Минск, ул. Кульман, д. 9",
      backToTop: "Наверх",
      copyright: "© {year} StackAdvance. Все права защищены."
    }
  },
  en: {
    navigation: {
      about: "About",
      products: "Products",
      services: "Services",
      news: "News",
      contact: "Contact",
      connect: "Contact Us"
    },
    language: {
      ru: "Russian",
      en: "English"
    },
    footer: {
      description: "Software development for retail, ecommerce and logistics.",
      navigation: "Navigation",
      home: "Home",
      about: "About",
      products: "Products",
      services: "Services",
      resources: "Resources",
      news: "News",
      contacts: "Contacts",
      address: "Minsk, Kulyman St., 9",
      backToTop: "Back to top",
      copyright: "© {year} StackAdvance. All rights reserved."
    }
  }
} as const;